import { combineReducers } from 'redux';
import redux from './redux';

// Combine reducer
const reducer = combineReducers({
  redux
});

export default reducer;

